import React, { Component } from 'react';
import { connect } from 'react-redux';
import CardActionRecommendationView from './CardActionRecommendation.view';

export class CardActionRecommendationContainer extends Component {

  constructor(props){
    super(props);
    this.state = {
    };
  }

  render() {
    return (<CardActionRecommendationView
      {...this.props}
      {...this.state}
    />);
  }

}

function mapStateToProps(state, ownProps) {
  return {
    trade: ownProps.trade,
  };
}

export default connect(mapStateToProps)(CardActionRecommendationContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/CardActionRecommendation/CardActionRecommendation.container.js